import { render, staticRenderFns } from "./DoctorAdd.vue?vue&type=template&id=02678a6e&"
import script from "./DoctorAdd.vue?vue&type=script&lang=js&"
export * from "./DoctorAdd.vue?vue&type=script&lang=js&"
import style0 from "./DoctorAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports